import React from 'react';
import { Col, Row } from 'antd';
import PersonInfo from 'Components/person/components/PersonInfo';
// import { useSelector } from 'react-redux';
// import { selectSRICardData, selectSRICardLoading } from 'Selector/SRISelector';
import styled from 'styled-components';
import { maxWidth, retina } from 'Utils/utilsStyle';
import SinglePersonCardSkeleton from 'Components/common/skeleton/SinglePersonCardSkeleton';
import { SRIuserOverviewCard } from 'Types/SRITypes';
import BadgeDetails from './BadgeDetails';
import { PersonCard } from 'Types/PersonTypes';

const Wrapper = styled.div`
  border-radius: 16px;
  background: #fff;
  padding: 40px 20px 40px 0px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 40px 20px 40px 0px;
  }
  .certified-svg{
    position: absolute;
    left: 0px;
    top: 0px;
    .certified-img {
      width: 132px;
    }
  }
  .progress-social {
    display: none;
  }
`;

type Props = {
  sriCardLoading: boolean;
  sriCardDetails: SRIuserOverviewCard;
  isDrag?: (d: boolean) => void
} & typeof defaultProps;

const defaultProps = {
  isDrag: (d: boolean) => { console.log(d); },
};

const SriProfile: React.FC<Props> = function SriProfile(props) {
  const { sriCardLoading, sriCardDetails, isDrag } = props;
  const personDetails: PersonCard = { ...sriCardDetails, email: '', phone: '', companyPulse: [], isSelected: false, isAdmin: false, companySubscribers: 0 }
  return (
    <Wrapper>
      {(sriCardDetails || sriCardLoading) ? (
        <div className="sri-person-card">
          {(sriCardDetails?.certified?.length && !sriCardLoading) ? (
            <div className="certified-svg">
              <img src={sriCardDetails?.certified} alt="certified-img" className="certified-img" />
            </div>
          ) : null}
          <Row className="align-item-center-100-res">
            <Col span={8}>

              {
                sriCardLoading ? <SinglePersonCardSkeleton />
                  : (
                    <div>
                      <PersonInfo
                        hideFollow
                        onClickHandler={() => { }}
                        personFollowLoading={false}
                        {...(sriCardDetails || {})}
                        personName={sriCardDetails?.personName}
                        personImage={sriCardDetails?.personImage}
                        personDesignation={sriCardDetails?.personDesignation}
                        companyPersonality={sriCardDetails?.companyPersonality}
                        isSriPage
                        isDrag={isDrag}
                        personInfo={personDetails}
                      />
                    </div>
                  )
              }
            </Col>
            <Col span={16}>
              <BadgeDetails
                level={sriCardDetails?.level}
                timeSpent={sriCardDetails?.time_spent}
                userTeamRank={sriCardDetails?.user_company_rank}
                scoreThisMonth={sriCardDetails?.score_current_month}
                companyViewed={sriCardDetails?.company_viewed}
                peopleViewed={sriCardDetails?.people_viewed}
                contentViewed={sriCardDetails?.content_viewed}
                loading={sriCardLoading}
                userTeamMember={sriCardDetails.user_company_members}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default SriProfile;
